import { render } from "./TemplatesIndex.vue?vue&type=template&id=60d91c16"
import script from "./TemplatesIndex.vue?vue&type=script&lang=js"
export * from "./TemplatesIndex.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__